import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {ProductOrderStatus} from '@web/core/constants'
import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const recommendationProductSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(
            getShoppingSubscriptionResultInfo.fulfilled,
            (
                state,
                {
                    payload: {
                        subscriptionResultViewInfo: {products},
                    },
                },
            ) => {
                state.products = products.map((product) => {
                    return {
                        ecNvMid: product.ecNvMid ?? undefined,
                        orderDateTime: product.registerDateTime ?? undefined,
                        productOrderStatus: ProductOrderStatus.NONE,
                        productPaymentAmount: product.orderAmount ?? undefined,
                        productCategoryId: product.productCategoryId ?? undefined,
                    }
                })
            },
        )
    },
})

export default recommendationProductSlice.reducer
